import { useTranslation } from 'react-i18next'

import { ClipboardTextIcon, CoinsIcon, GlobeHemisphereWestIcon } from '@phosphor-icons/react'

import { CountryFlag, FormatNumber, FormatPrice } from '@reveni-io/reveni-ui'

import Statistic from '@/common/components/Statistic/Statistic'
import StatisticGroup from '@/common/components/StatisticGroup/StatisticGroup'

import { getRegionByCode } from '../helpers'
import MotionContainer from '../MotionContainer/MotionContainer'
import * as Styles from './styles'

const GlobalInfo = ({ metrics, currency, regions }) => {
  const { t } = useTranslation()
  const topRegion = getRegionByCode(regions, metrics?.top_region)

  return (
    <MotionContainer>
      <StatisticGroup>
        <Statistic
          size="small"
          isOutlined={false}
          label={t('Pedidos totales')}
          Icon={ClipboardTextIcon}
          value={<FormatNumber style="decimal">{metrics?.total_orders_count}</FormatNumber>}
        />
        <Statistic
          size="small"
          isOutlined={false}
          label={t('Valor total de pedidos')}
          Icon={CoinsIcon}
          value={<FormatPrice currency={currency}>{metrics?.total_order_value}</FormatPrice>}
        />
        <Statistic
          size="small"
          isOutlined={false}
          label={t('Valor medio de pedido')}
          Icon={CoinsIcon}
          value={<FormatPrice currency={currency}>{metrics?.average_order_value}</FormatPrice>}
        />
        <Statistic
          size="small"
          isOutlined={false}
          label={t('Región con más pedidos')}
          Icon={GlobeHemisphereWestIcon}
          value={
            <Styles.TopRegionContainer>
              <CountryFlag code={topRegion?.country?.code} />
              {topRegion?.country?.name}
            </Styles.TopRegionContainer>
          }
        />
      </StatisticGroup>
    </MotionContainer>
  )
}

export default GlobalInfo
